import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { PayAccount } from '@app/modules/model/payaccount';
import { TicketList } from '@app/modules/model/payaccount';

import { languageSupport, languageService } from '@app/modules/common/language'
import { dataService } from '@app/modules/data';
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-payaccount-thumbnail',
    templateUrl:'./ui-thumb.html',
    styleUrls: [ 
        './ui-thumb.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiPayAccountThumbnail extends languageSupport implements OnInit, OnDestroy {
    @Input('account') _account: PayAccount = null;

    private _placetickets = new TicketList ();
    private get Tickets(){
        return this._placetickets;
    }

    private _isloading = true;
    get IsLoading(){
        return this._isloading;
    }

    set IsLoading(value){
        this._isloading = value;
        this.change.markForCheck();
    }

    get AmountPending(){
        let _price = 0;
        
        for(let _ticket of this.Tickets){
            if (_ticket.IsToPay){
                _price += _ticket.price;
            }
        }

        let _parts = (Math.abs(_price)).toString().split('.');

        let _int = _parts[0];
        let _dec = (_parts.length > 1) ? (_parts[1] + '0').slice(0, 2) : "00";
        let _str = _int + ',' + _dec;
        let _neg = (_price < 0); 

        return {
            Int: _int,
            Dec: _dec,
            Str: _str,
            Neg: _neg
        }    
    }
    
    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    private get reports(){
        return this.data.Reports;
    }

    constructor(private lang: languageService, private change: ChangeDetectorRef, private data: dataService, public view: viewService) {
        super(lang, change);
    }

    private _place_subscriptions = [];
    private _account_subscription = null;
    private _online_subscription = null;

    private async _OnRefreshAccount(){
        let _tickets = this._account.place.tickets;
        for(let _ticket of _tickets){
            if (_ticket.account == this._account){
                (_ticket.IsValid) ? this._placetickets.add(_ticket) : this._placetickets.del(_ticket);
            }
        }

        this.change.markForCheck();
    }    

    private async LoadAccountTickets(){
        let _tickets = await this.reports.AccountTickets(this._account);
        for(let _ticket of _tickets){
            this._placetickets.add(_ticket);
        }

        this._OnRefreshAccount();
    }

    private async _ReloadTickets(){
        this.IsLoading = true;
        if (this.view.IsOnline){
            await this.LoadAccountTickets();
            this.IsLoading = false;      
        }
    }

    async ngOnInit(){
        let _place = null;

        if (this._account){
            _place = this._account.place;

            this._account_subscription = this._account.OnRefresh.subscribe(
            data => {
                this.change.markForCheck();
            });        
        }

        if (_place){
            this._ReloadTickets();

            this._online_subscription = this.view.OnOnline.subscribe(
                data => {
                    this._ReloadTickets();
                });
        
            this._place_subscriptions.push(
                _place.OnTargetRefresh('TICKET').subscribe(
                data => {
                    this._OnRefreshAccount();
                })
            );
    
            this._place_subscriptions.push(
                _place.OnTargetRefresh('CLIENT').subscribe(
                data => {
                    this._OnRefreshAccount();
                })
            );            
        }
    }

    ngOnDestroy(){
        super.OnDestroy();

        if (this._online_subscription){
            this._online_subscription.unsubscribe();
            this._online_subscription = null;
        }

        if (this._account_subscription){
            this._account_subscription.unsubscribe();
            this._account_subscription = null;
        }

        for (let _subscription of this._place_subscriptions){
            _subscription.unsubscribe();
            _subscription = null;
        }
        this._place_subscriptions = [];
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/    

    @Output('onSelect') _onSelect = new EventEmitter<any>();         
    OnSelect(){
        this._onSelect.emit(this._account);
    }
}
